import { defineComponent as _defineComponent } from 'vue';
import { ref, onMounted, watch } from 'vue';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'index',
    props: {
        imageList: null,
        order: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        // @todo
        const privacyMode = localStorage.getItem('privacyMode') || 'false';
        onMounted(() => { });
        const isShow = ref(false);
        watch(() => props.order, (value) => {
            // console.log('===value',!value);
            isShow.value = !value;
        });
        function onLoadFn() {
            isShow.value = true;
        }
        return { __sfc: true, props, privacyMode, isShow, onLoadFn, BlurPicture };
    }
});
